'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countries = exports.isStagePending = exports.isStageSkipped = exports.isStageInProgress = exports.isStageComplete = exports.splitCamelCase = exports.validateMobile = exports.validateEmail = exports.getStageStatus = exports.filterTask = exports.filterData = exports.isEmpty = exports.isEqual = exports.contains = exports.convertIconName = exports.replaceAll = exports.toArray = exports.toJSSafe = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toJSSafe = exports.toJSSafe = function toJSSafe(obj) {
  if (obj) {
    return obj.toJS();
  } else {
    return null;
  }
};

var toArray = exports.toArray = function toArray(obj) {
  return _lodash2.default.keys(obj).map(function (id) {
    return _lodash2.default.assign({ id: id }, obj[id]);
  });
};

var replaceAll = exports.replaceAll = function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, 'g'), replace);
};

var convertIconName = exports.convertIconName = function convertIconName(icon) {
  return replaceAll(icon, '-', '_');
};
var contains = exports.contains = function contains(string, substring) {
  return string.includes(substring);
};
var isEqual = exports.isEqual = function isEqual(string, substring) {
  return string === substring;
};
var isEmpty = exports.isEmpty = function isEmpty(value) {
  return !value;
};

var filterData = exports.filterData = function filterData(value, condition, substring) {
  switch (condition) {
    case 'Contains':
      return contains(value.toLowerCase(), substring.toLowerCase());
    case 'Does not contain':
      return !substring || !contains(value.toLowerCase(), substring.toLowerCase());
    case 'Is':
      return isEqual(value.toLowerCase(), substring.toLowerCase());
    case 'Is not':
      return !isEqual(value.toLowerCase(), substring.toLowerCase());
    case 'Is empty':
      return isEmpty(value.toLowerCase(), substring.toLowerCase());
    case 'Is not empty':
      return !isEmpty(value.toLowerCase(), substring.toLowerCase());
    default:
      return true;
  }
};

var filterTask = exports.filterTask = function filterTask(task) {
  var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return rules.reduce(function (res, rule) {
    if (res) {
      console.log(rule.where(task), rule.condition, rule.substring);
      return filterData(rule.where(task), rule.condition, rule.substring);
    }

    return res;
  }, true);
};

var getStageStatus = exports.getStageStatus = function getStageStatus(task, stage) {
  if (!task) {
    return {
      code: 'U',
      name: 'Unknown',
      icon: 'unknown',
      color: 'lightgrey'
    };
  }

  if (!task.stages || !task.stages[stage.id]) {
    return {
      code: 'P',
      name: 'Pending',
      icon: 'clear',
      color: 'grey'
    };
  }

  var taskStage = task.stages[stage.id];
  if (taskStage.skipped) {
    return {
      code: 'SK',
      name: 'Skipped',
      icon: 'skip_next',
      color: 'grey'
    };
  }

  if (taskStage.completed) {
    return {
      code: 'C',
      name: 'Complete',
      icon: 'done',
      color: 'green'
    };
  }

  if (taskStage.started) {
    return {
      code: 'IP',
      name: 'In Progress',
      icon: 'autorenew',
      color: 'orange'
    };
  }

  return {
    code: 'P',
    name: 'Pending',
    icon: 'clear',
    color: 'red'
  };
};
var validateEmail = exports.validateEmail = function validateEmail(email) {
  return (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
  );
};
var validateMobile = exports.validateMobile = function validateMobile(mobile) {
  return (/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(mobile)
  );
};
var splitCamelCase = exports.splitCamelCase = function splitCamelCase(camelCase) {
  return camelCase.replace(/([A-Z])/g, ' $1').toLowerCase();
};
var isStageComplete = exports.isStageComplete = function isStageComplete(task, stage) {
  return getStageStatus(task, stage).code === 'C';
};
var isStageInProgress = exports.isStageInProgress = function isStageInProgress(task, stage) {
  return getStageStatus(task, stage).code === 'IP';
};
var isStageSkipped = exports.isStageSkipped = function isStageSkipped(task, stage) {
  return getStageStatus(task, stage).code === 'SK';
};
var isStagePending = exports.isStagePending = function isStagePending(task, stage) {
  return getStageStatus(task, stage).code === 'P';
};

var countries = exports.countries = ['United Kingdom', 'United States', 'Canada', 'Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bangladesh', 'Barbados', 'Bahamas', 'Bahrain', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'British Indian Ocean Territory', 'British Virgin Islands', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo-Brazzaville', 'Congo-Kinshasa', 'Cook Islands', 'Costa Rica', 'Croatia', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'El Salvador', 'Egypt', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Federated States of Micronesia', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Lands', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and McDonald Islands', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn Islands', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russia', 'Rwanda', 'Saint Barthélemy', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin', 'Saint Pierre and Miquelon', 'Saint Vincent', 'Samoa', 'San Marino', 'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Korea', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Sweden', 'Swaziland', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Vietnam', 'Venezuela', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sakari-io/staza-common/dist/helper.js
// module id = 559
// module chunks = 0